<div class="modal-header d-flex">
    <div class="modal-title">Sources</div>
    <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <div class="modal-close-icon"></div>
    </div>
</div>
<div class="form-height accordion-div modal-body" [ngClass]="{ 'pl-1r': isMobile }">
    <accordion [isAnimated]="true" [closeOthers]="false">
        <!-- Web Site Urls-->
        <accordion-group
            heading="Web"
            [isOpen]="true"
            #accordionwebsource
            [ngClass]="{ accordionactive: accordionwebsource?.isOpen, accordionNotactive: !accordionwebsource?.isOpen }"
        >
            <span accordion-heading>
                <fa-icon
                    class="float-end"
                    [ngClass]="accordionwebsource?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                    [icon]="accordionwebsource?.isOpen ? faAngleUp : faAngleDown"
                ></fa-icon>
            </span>
            <div>
                <div class="pt-3">
                    <!-- <div class="font-12"><span class="font-weight-600" title="set sources of your preferences">Preferred Sources</span><span class="pl-5px"></span></div> -->
                    <div class="row d-flex mb-2 pl-3">
                        <div class="col-10 col-sm-8">
                            <input
                                *ngIf="!isMobile"
                                type="text"
                                [(ngModel)]="webURL"
                                class="form-control website-text-box"
                                placeholder="'http://abc.com' or 'https://abc.com'"
                                (keydown.enter)="addWebURLArray()"
                                autofocus
                            />
                            <input
                                *ngIf="isMobile"
                                type="text"
                                [(ngModel)]="webURL"
                                class="form-control website-text-box"
                                placeholder="'http://abc.com' or 'https://abc.com'"
                                autofocus
                            />
                        </div>
                        <button type="button" class="add-icon position-add" (click)="addWebURLArray()"></button>
                    </div>
                    <!-- <div class="example-text">for ex "http://abc.com" or "https://abc.com"</div> -->
                    <div class="d-flex pl-3 flex-wrap">
                        <div class="p-2" *ngFor="let itm of webURLArray; let i = index">
                            <div class="pl-3 cursor-pointer font-14 dynamic-width" (click)="editWebURL(itm)">
                                {{ itm }}
                                <button type="button" class="btn-close font-9" (click)="removeWebURL(itm)"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pt-3">
                    <form [formGroup]="form">
                        <div class="row mt-1" *ngIf="fields.controls.length > 0 && !isMobile">
                            <div class="col-12 col-sm-4 pe-1">
                                <div class="form-group">
                                    <label class="mb-2 ml-2 font-14"> Special Sources</label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-3 pe-1">
                                <div class="form-group">
                                    <label class="mb-2 ml-2 font-14"> Parameter</label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-3 pe-1">
                                <div class="form-group">
                                    <label class="mb-2 ml-2 font-14">Value</label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-1"></div>
                            <div class="col-12 col-sm-1"></div>
                        </div>

                        <div class="special-sources-form" formArrayName="fields" *ngFor="let field of fields.controls; let i = index">
                            <div [formGroupName]="i">
                                <div class="row mt-1">
                                    <div class="col-12 col-sm-4 pe-1">
                                        <label class="mb-2 ml-2" *ngIf="isMobile"> Special Sources</label>
                                        <div class="form-group">
                                            <select class="form-control form-control-color" formControlName="key" (change)="onKeyChange(i)">
                                                <option value="">Select</option>
                                                <option *ngFor="let source of sourceKeys" [value]="source" [disabled]="isKeyDisabled(source)">{{ source }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="fields.at(i).get('key')?.value">
                                        <div class="col-12 col-sm-3 pe-1">
                                            <div class="form-group">
                                                <label class="mb-2 ml-2 mt-2" *ngIf="isMobile"> Parameter</label>
                                                <input
                                                    type="text"
                                                    class="form-control website-text-box"
                                                    formControlName="parameter"
                                                    [ngClass]="{ 'disable-input': fields.at(i).get('key')?.disabled }"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-3 pe-1">
                                            <div class="form-group" *ngIf="!isMobile">
                                                <input type="text" class="form-control website-text-box" formControlName="values" placeholder="Value1, Value2..." />
                                            </div>

                                            <div class="row" *ngIf="isMobile">
                                                <div class="col-8 col-sm-1 pe-1">
                                                    <div class="form-group">
                                                        <label class="mb-2 ml-2 mt-2">Value</label>
                                                        <input type="text" class="form-control website-text-box" formControlName="values" placeholder="Value1, Value2..." />
                                                    </div>
                                                </div>
                                                <div class="col-2 col-sm-1 pe-1">
                                                    <div class="form-group pt-35">
                                                        <input
                                                            type="checkbox"
                                                            formControlName="includeSubTopic"
                                                            class="cursor-pointer flex-start include-subtopic-check mx-2"
                                                            title="Include Subtopic"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-2 col-sm-1">
                                                    <div class="form-group pt-35">
                                                        <div
                                                            class="col-1 special-sources-delete-icon include-subtopic-delete"
                                                            (click)="deleteSpecialSource(i)"
                                                            title="Delete"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-1 pe-1" *ngIf="!isMobile">
                                            <div class="form-group">
                                                <input
                                                    type="checkbox"
                                                    formControlName="includeSubTopic"
                                                    class="cursor-pointer flex-start include-subtopic-check mx-2"
                                                    title="Include Subtopic"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-1 pb-2" *ngIf="!isMobile">
                                            <div class="form-group">
                                                <div class="col-1 special-sources-delete-icon include-subtopic-delete" (click)="deleteSpecialSource(i)" title="Delete"></div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="mt-2 d-flex align-items-center" [ngClass]="{ disabledDiv: isSpecialSourcesButtonDisabled }">
                        <div class="cursor-pointer" (click)="AddSpecialSources()">
                            <span class="special-sources mr-2"></span>
                            <span class="spl-soruce-heading">Special Sources</span>
                        </div>
                    </div>
                </div>
            </div>
        </accordion-group>
        <!-- Gyan Knowledge Store-->
        <accordion-group
            heading="Knowledge Stores"
            [isOpen]="false"
            #accordionknowledge
            [ngClass]="{
                accordionactive: accordionknowledge?.isOpen,
                accordionNotactive: !accordionknowledge?.isOpen,
                'knowledge-store': !isMobile,
                'knowledge-store-mobile': isMobile,
            }"
        >
            <span accordion-heading>
                <fa-icon
                    class="float-end"
                    [ngClass]="accordionknowledge?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                    [icon]="accordionknowledge?.isOpen ? faAngleUp : faAngleDown"
                ></fa-icon>
            </span>
            <div class="gyan-knowledge-store">
                <app-gyan-knowledge-store [topic]="topic" [gksLevel]="gksLevel"></app-gyan-knowledge-store>
                <!-- (sendCheckedListGKS)="getCheckedItemListGKS()" -->
            </div>
        </accordion-group>
        <!-- My Knowledge Store -->
        <accordion-group
            heading="My Content"
            [isOpen]="false"
            #Gyanaccordionknowledge
            [ngClass]="{
                accordionactive: Gyanaccordionknowledge?.isOpen,
                accordionNotactive: !Gyanaccordionknowledge?.isOpen,
                'my-knowledge-store': !isMobile,
                'my-knowledge-store-mobile': isMobile,
            }"
        >
            <span accordion-heading>
                <fa-icon
                    class="float-end"
                    [ngClass]="Gyanaccordionknowledge?.isOpen ? 'highlighted-text' : 'nohighlight-text'"
                    [icon]="Gyanaccordionknowledge?.isOpen ? faAngleUp : faAngleDown"
                ></fa-icon>
            </span>
            <div class="my-knowledge-store">
                <app-my-knowledge-store [topic]="topic" [gksLevel]="gksLevel"></app-my-knowledge-store>
                <!-- (sendCheckedListMKS)="getCheckedItemListMKS()" -->
            </div>
        </accordion-group>
    </accordion>
</div>
<div class="modal-footer border-0">
    <button type="button" class="btn-custom btn-primary mr-3 cursor-pointer col-3 col-sm-2 float-end" (click)="saveWebUrlsFormToLocalStorage()">Save</button>
    <button type="button" class="btn-custom btn-primary mr-3 cursor-pointer col-3 col-sm-2" (click)="closeModal()">Cancel</button>
</div>
